// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WomanOutlinedSvg from "@fishx/icons-svg/es/asn/WomanOutlined";
import FishxIcon from '../components/FishxIcon';

var WomanOutlined = function WomanOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WomanOutlinedSvg
  }));
};

WomanOutlined.displayName = 'WomanOutlined';
export default React.forwardRef(WomanOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WomanOutlined.js
// module id = 4409
// module chunks = 0